import { number, string } from 'prop-types';
import React from 'react';
import { colors } from '@ajaibid/components';

const IconTransaction = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2071 2.29289C10.5976 2.68342 10.5976 3.31658 10.2071 3.70711L8.91421 5H14.5C18.366 5 21.5 8.13401 21.5 12V13C21.5 13.5523 21.0523 14 20.5 14C19.9477 14 19.5 13.5523 19.5 13V12C19.5 9.23858 17.2614 7 14.5 7H8.91421L10.2071 8.29289C10.5976 8.68342 10.5976 9.31658 10.2071 9.70711C9.81658 10.0976 9.18342 10.0976 8.79289 9.70711L5.79289 6.70711C5.40237 6.31658 5.40237 5.68342 5.79289 5.29289L8.79289 2.29289C9.18342 1.90237 9.81658 1.90237 10.2071 2.29289Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7929 21.7071C14.4024 21.3166 14.4024 20.6834 14.7929 20.2929L16.0858 19H10.5C6.63401 19 3.5 15.866 3.5 12V11C3.5 10.4477 3.94771 10 4.5 10C5.05229 10 5.5 10.4477 5.5 11V12C5.5 14.7614 7.73858 17 10.5 17H16.0858L14.7929 15.7071C14.4024 15.3166 14.4024 14.6834 14.7929 14.2929C15.1834 13.9024 15.8166 13.9024 16.2071 14.2929L19.2071 17.2929C19.5976 17.6834 19.5976 18.3166 19.2071 18.7071L16.2071 21.7071C15.8166 22.0976 15.1834 22.0976 14.7929 21.7071Z"
      fill={color}
    />
  </svg>
);

IconTransaction.propTypes = {
  color: string,
  size: number,
};

IconTransaction.defaultProps = {
  color: colors.AJAIB_BLUE_5,
  size: 24,
};

export default IconTransaction;
